"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPropTypes = void 0;
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@mui/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SelectPropTypes = exports.SelectPropTypes = {
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _propTypes["default"].string,
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _propTypes["default"].bool,
  /**
   * If `true`, the `options` sorted by selected values as first.
   */
  firstSelected: _propTypes["default"].bool,
  /**
   * @ignore
   */
  children: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['primary', 'secondary']),
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes["default"].string,
  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: _propTypes["default"].object,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * The helper text content.
   */
  helperText: _propTypes["default"].node,
  /**
   * @ignore
   */
  hiddenLabel: _propTypes["default"].bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes["default"].string,
  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: _propTypes["default"].object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _propTypes["default"].object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: _propTypes["default"].object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _utils.refType,
  /**
   * The label content.
   */
  label: _propTypes["default"].node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes["default"].oneOf(['dense', 'none', 'normal']),
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes["default"].string,
  /**
   * @ignore
   */
  onBlur: _propTypes["default"].func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes["default"].func,
  /**
   * @ignore
   */
  onFocus: _propTypes["default"].func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes["default"].string,
  /**
   * The short hint displayed in the input in dropdown before the user enters a value.
   */
  dropdownInputPlaceholder: _propTypes["default"].string,
  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: _propTypes["default"].bool,
  /**
   * If `true`, show loading state
   */
  loading: _propTypes["default"].bool,
  /**
   * If `true`, show fetching state
   */
  fetching: _propTypes["default"].bool,
  /**
   * The size of the text field.
   */
  size: _propTypes["default"].oneOf(['medium', 'small']),
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _propTypes["default"].any,
  /**
   * Show suffix icon with tooltip "This field cannot be edited once saved."
   */
  isDenyEdit: _propTypes["default"].bool,
  /**
   * Count elements in text field.
   */
  previewItemsCount: _propTypes["default"].number,
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['filled', 'outlined', 'standard']),
  onAdd: _propTypes["default"].func,
  addOptionLabel: function addOptionLabel(props, propName) {
    var _props$onAdd;
    if ((0, _lodash.isFunction)(props.onAdd) && !((_props$onAdd = props.onAdd) !== null && _props$onAdd !== void 0 && _props$onAdd._isMockFunction) && props[propName] === undefined) {
      return new Error("".concat(propName, " is marked as required, when onAdd prop is passed"));
    }
  },
  favorits: _propTypes["default"].array,
  favoritsLabel: function favoritsLabel(props, propName) {
    if (props.favorits && props[propName] === undefined) {
      return new Error("".concat(propName, " is marked as required, when favorits prop is passed"));
    }
  }
};